import { Icon } from "@/components/general/icon/Icon";
import style from "./CurrencyTag.module.css";
import globe from "@/assets/icons/globe-icon.svg";
import type { EIcon } from "@/utils/enums";

export const CurrencyTag = ({ currencyCode }: { currencyCode: string }) => {
  return (
    <div className={style.wrapper}>
      <div className={style["icon-container"]}>
        <Icon
          name={`flags/${currencyCode.toLocaleLowerCase()}-flag` as EIcon}
          fallback={globe}
        />
      </div>
      <span>{currencyCode}</span>
    </div>
  );
};
